var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c(
        "b-card",
        { staticClass: "mb-4" },
        [
          _c(
            "b-row",
            { attrs: { "align-v": "center" } },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "6", lg: "4" } },
                [
                  _c("label", { staticClass: "mb-2 font-weight-bold" }, [
                    _vm._v("Select Date Range to View Reports"),
                  ]),
                  _c("DatePicker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      range: "",
                      format: "YYYY-MM-DD",
                      placeholder: "Select date range",
                      size: "sm",
                    },
                    on: { change: _vm.handleDateRangeChange },
                    model: {
                      value: _vm.dateRange,
                      callback: function ($$v) {
                        _vm.dateRange = $$v
                      },
                      expression: "dateRange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass: "mt-3 mt-md-0",
                  attrs: { cols: "12", md: "6", lg: "4" },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-md-2",
                      attrs: { variant: "primary", disabled: !_vm.dateRange },
                      on: { click: _vm.handleDateRangeChange },
                    },
                    [_vm._v(" Refresh Reports ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.loading || _vm.reportLoading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-4" },
            [
              _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "primary", label: "Loading reports..." },
              }),
              _c("p", { staticClass: "ml-3 mb-0 align-self-center" }, [
                _vm._v("Loading reports..."),
              ]),
            ],
            1
          )
        : _vm._e(),
      !_vm.dateRange && !_vm.loading && !_vm.reportLoading
        ? _c("b-alert", { attrs: { show: "", variant: "info" } }, [
            _vm._v(" Please select a date range above to view the reports. "),
          ])
        : _vm._e(),
      _vm.dateRange && !_vm.loading && !_vm.reportLoading
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("Ticketingchart", {
                    attrs: { data: _vm.ticketCategoryReport },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("Ass", {
                    attrs: { data: _vm.complainResolutionTimeReport },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("StaffChart", {
                    attrs: { data: _vm.staffComplaintHandlingPerformance },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("Complaint", {
                    attrs: { data: _vm.customerComplaintFrequency },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("LeadClientOpportunityChart", {
                    attrs: { data: _vm.leadClientOpportunityCostSummary },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("CustomerTicketVolumeChart", {
                    attrs: { data: _vm.customerTicketVolumeAnalysis },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("MoreAnalytics1", {
                    attrs: { data: _vm.salesSummaryReport },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("MoreAnalytics2", {
                    attrs: { data: _vm.salesAnalyticsReport },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("MoreAnalytics3", {
                    attrs: { data: _vm.salesAnalyticsReportByClient },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("MoreAnalytics4", {
                    attrs: { data: _vm.salesAnalyticsReportByProduct },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("QuotationPriorityChart", {
                    attrs: { data: _vm.quotationPriorityReport },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("ContributionBarChart", {
                    attrs: { data: _vm.SalesValueContributionBySalesperson },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("LeadAgingBarChart", {
                    attrs: { data: _vm.LeadAgingAnalysis },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("ChartSales", {
                    attrs: {
                      sales: _vm.salesOrderList,
                      totalSales: _vm.totalSalesAmount,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }